import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import { Odom } from '../../HomePage/components/Highlights';
import greenPeople from '../../../assets/images/leadersForStandardsAndSolutions/greenPeople.png';
import commercialLines from '../../../assets/images/commercialLines.png';

const CLDataStandardsHighlights = () => (
  <Container>
    <Row>
      <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 300,
          height: 300,
          borderRadius: '50%',
          backgroundColor: '#F8F8F6',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 20
          }}>
            <img
              src={greenPeople}
              width="48px"
              height="48px"
              alt=""
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 32,
            width: 260,
            height: 260,
            borderRadius: 130,
            // backgroundColor: '#F8F8F6',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 40,
          }}>
            <div style={{ height: 72 }}>
              <Odom number={94} text="%" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#1B526D',
                marginTop: 0
              }}
                textStyle={{
                  fontSize: 60,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#1B526D',
                  marginTop: 32
                }}
              />
            </div>
            <div style={{
              fontSize: 14,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#48604C',
              textAlign: 'center'
            }}>
              OF BROKERS SUPPORT
              INDUSTRY-WIDE IMPLEMENTATION  <span style={{ color: '#8A9D76', fontSize: 18 }}>OF CL DATA STANDARDS</span>
            </div>
            <div style={{ fontSize: 12, textAlign: 'center', fontFamily: 'montserrat medium' }}>
              Source: CSIO Broker<br /> survey
            </div>
          </div >
        </div>
      </Col>
      <Col  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 30}}>
        <div style={{
          width: 300,
          height: 300,
          borderRadius: '50%',
          backgroundColor: '#E8EFF2',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <div style={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 20,
          }}>
            <img
              src={commercialLines}
              width="52px"
              height="56px"
              alt=""
              style={{marginRight: 16}}
            />
          </div>
          <div style={{
            margin: 25,
            marginTop: 32,
            width: 260,
            height: 260,
            borderRadius: 130,
            // backgroundColor: '#E8EFF2',
            display: 'flex',
            // alignItems: 'center',
            // justifyContent: 'center',
            flexDirection: 'column',
            fontFamily: '',
            padding: 16,
            paddingTop: 40,
          }}>
            <div style={{ height: 64 }}>
              <Odom number={91} text="%" odomStyle={{
                fontSize: 60,
                fontFamily: 'montserrat bold',
                fontWeight: 'bold',
                color: '#EECA41',
                marginTop: 0
              }}
                textStyle={{
                  fontSize: 60,
                  fontFamily: 'montserrat bold',
                  fontWeight: 'bold',
                  color: '#EECA41',
                  marginTop: 32
                }}
              />
            </div>
            <div style={{
              fontSize: 14,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              textAlign: 'center',
              marginTop: 10
            }}>
              OF BROKERAGES SAY THEY ARE <span style={{ color: '#1C1F3D', fontSize: 16, lineHeight: 1 }}>MORE
                LIKELY</span>  TO WORK WITH INSURERS WHO
              HAVE <span style={{ color: '#1C1F3D', fontSize: 16, lineHeight: 1 }}>IMPLEMENTED THE STANDARDS</span>
            </div>
            <div style={{ textAlign: 'center', fontFamily: 'montserrat medium', fontSize: 12 }}>
              Source: CSIO Broker<br /> survey
            </div>
          </div >
        </div>
      </Col>
    </Row>
  </Container>
)

export default CLDataStandardsHighlights;
